import { isAfter } from 'date-fns';

import type {
  EnumAccessType,
  ResponseElevationResponse,
} from '@internal/backstage-plugin-neo4j-permission-elevation-common';
import type { ElevationResult } from '../types';

export type ElevationRecords = Partial<Record<EnumAccessType, ElevationResult>>;

export function toElevationResult(
  response: Pick<
    ResponseElevationResponse,
    'requestedAt' | 'estimatedExpiresAt'
  >,
): ElevationResult {
  return {
    requestedAt: response.requestedAt.toISOString(),
    estimatedExpiresAt: response.estimatedExpiresAt.toISOString(),
  };
}

/**
 * The records whose estimated expiry has not passed. Stored records act as
 * their own time to live: an expired record is ignored and dropped on the
 * next write.
 */
export function activeRecords(
  records: ElevationRecords,
  now = new Date(),
): ElevationRecords {
  return Object.fromEntries(
    Object.entries(records).filter(([, record]) =>
      isAfter(new Date(record.estimatedExpiresAt), now),
    ),
  );
}
